module.exports = __webpack_public_path__ + "img/return.f55e2b4a.svg";